import { render } from "./Offcanvas.vue?vue&type=template&id=27c2b48f"
import script from "./Offcanvas.vue?vue&type=script&lang=js"
export * from "./Offcanvas.vue?vue&type=script&lang=js"
script.render = render

export default script